import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../ui/display/media/vimeo-player.component';
import { CMS_COMPONENT_VIDEO_CONFIG } from './cms-component-video.config';
import { NCmsComponentVideo } from './cms-component-video.interface';

@Component({
    selector: 'cms-component-video',
    templateUrl: './cms-component-video.component.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, LocalVimeoPlayerComponent, YoutubePlayerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentVideoComponent>(CMS_COMPONENT_VIDEO_CONFIG)
export class CmsComponentVideoComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentVideo.IData;
}
